// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* conteneur englobant l'ensemble des informations */
table{
    border-collapse:collapse;
}
tr>td {
  padding: 5px;
}
table,
tr,
td,
div {
    page-break-inside: avoid;
}
.EtiquetteAccessoires{
	width: 7cm;
	height: 3cm;
	border: solid 0.1px;

}
.logoP2BouPromoAccessoiresPrixDebadCenter{
	display: inline-block;
}
.logoP2BouPromoAccessoiresPromo {
	background-color: #e8182e;
    color: #fff;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70%;
    height: 19px;
	 font-size: 10px;
    font-weight: bold;
   
}
.logoP2BouPromoAccessoiresPrixDebad{
	   display: flex;
    justify-content: center;
      align-items: end;
}
.dlpro-manufacturer-name-custom{
	font-size: 10px;
    width: 100%;
}
.logoP2BouPromoAccessoiresPrixDebad span{
       font-size: 11px;
    margin-right: 2px;
    line-height: 14px;
}
.logoP2BouPromoAccessoiresPrixDebad img{
	        width: 50%;
}
.no-margin-print{margin-top: 20px;}
.no-margin-top-left{
	margin-top: 20px;
	margin-left: 25px;
}
.no-padding-print{
	padding-left: 90px !important;
}
.EtiquetteAccessoiresSize{
	width: 7cm;
	height: 3cm;

}
.accessoiresCheckGreen {
    position: absolute;
    top: 5px;
    left: 5px;
}
.accessoiresCheckGreen img{
    width: 20px;
}  
.accessoiresBlockTop{
	position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
	    margin-top: -10px;    width: inherit;
}
.accessoiresBlockTop img{
	    width: 70px;
}
.accessoiresBlockCenter{
	position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    margin: 10px 0;
}

.etiquetteDailyMailing .EtiquetteAccessoires{

}
.conteneurEtiquetteAccessoires {
      display: block;
    width: 7cm;
	height: 3cm;
}

/* conteneur représentant la partie gauche de l'étiquette (logo, ref, caractéristiques) */
.conteneurCaracteristiquesAccessoires {
	width: 60%;
    float: left;
	    position: relative;
		height: 100%;
}

.logoFabricantAccessoires {
    top: 0;
    width: 100%;
}

.logoFabricantAccessoires img {
  height: 20px;
  margin: 2px 0 0 2px;
}

.logoFabricantAccessoires img + img {
 height: 20px;
    float: right;
    margin-right: 5px;
    margin-top: 5px;
}

.PVCAccessoires img{
	    height: 30px;
}

.bigSizeEtiquetteAccessoires {
      color: red;
    font-size: 11px;
    font-weight: 600;
   width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
}

.smallSizeEtiquetteAccessoires {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
}

.caracteristiquesProduitAccessoires {
  color: var(--grey-color);
  font-weight: 600;
  font-size: 7px;
      position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
}

/* conteneur représentant la partie droite de l'étiquette (PVC, logo P2B ou Promo, PV) */

.conteneurPrixAccessoires {
	width: 40%;
	float: left;
	height: 100%;
	overflow: hidden;
	    position: relative;
}

.PVCAccessoires {
     color: #000;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    
    background: #ffff;
    position: relative;
	    margin-top: 10px;
		 margin-right: 2px;
}

.PVCAccessoiresPrice {
        position: absolute;
    top: 5px;
    right: 0;
    text-align: center;
    font-size: 12px;
    line-height: 10px;
    width: 100%;
}

.PVCAccessoiresPrice span {
	text-decoration: line-through;
}

.logoP2BouPromoAccessoires {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
      margin: 20px 0 2px;
}


.PVAccessoires {
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}


.PVAccessoires {
    color: white;
    display: flex;
    flex-direction: column;
    font-size: 22px;
    font-weight: 600;
	    position: relative;
		 margin-right: 2px;
}
.PVAccessoiresPrice{
	    position: absolute;
    top: 2px;
    right: 0;
    text-align: center;
    width: 100%;
    font-size: 14px;
}
@media print {
	.no-print{
		display: none !important;
	}
  table { page-break-after:auto }
  table tr    { page-break-inside:avoid; page-break-after:auto }
  table thead { display:table-header-group }
  table tfoot { display:table-footer-group }
  .page-break  { display: block; page-break-before: always; }
  .no-padding-print{ padding-left: 0 !important;}
  .no-margin-print{margin-top: 0;}
  .no-margin-top-left{ margin-top: 0; margin-left: 0;}
 }
 @media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/EtiquetteAccessoires.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B;AACA;EACE,YAAY;AACd;AACA;;;;IAII,wBAAwB;AAC5B;AACA;CACC,UAAU;CACV,WAAW;CACX,mBAAmB;;AAEpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,yBAAyB;IACtB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;EACd,eAAe;IACb,iBAAiB;;AAErB;AACA;IACI,aAAa;IACb,uBAAuB;MACrB,gBAAgB;AACtB;AACA;CACC,eAAe;IACZ,WAAW;AACf;AACA;OACO,eAAe;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;SACS,UAAU;AACnB;AACA,iBAAiB,gBAAgB,CAAC;AAClC;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,UAAU;CACV,WAAW;;AAEZ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;CACC,kBAAkB;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;KAC1B,iBAAiB,KAAK,cAAc;AACzC;AACA;KACK,WAAW;AAChB;AACA;CACC,kBAAkB;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;AAEA;AACA;MACM,cAAc;IAChB,UAAU;CACb,WAAW;AACZ;;AAEA,yFAAyF;AACzF;CACC,UAAU;IACP,WAAW;KACV,kBAAkB;EACrB,YAAY;AACd;;AAEA;IACI,MAAM;IACN,WAAW;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;CACC,YAAY;IACT,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;KACK,YAAY;AACjB;;AAEA;MACM,UAAU;IACZ,eAAe;IACf,gBAAgB;GACjB,WAAW;IACV,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;MACV,kBAAkB;IACpB,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA,wFAAwF;;AAExF;CACC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,gBAAgB;KACZ,kBAAkB;AACvB;;AAEA;KACK,WAAW;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;;IAEf,iBAAiB;IACjB,kBAAkB;KACjB,gBAAgB;GAClB,iBAAiB;AACpB;;AAEA;QACQ,kBAAkB;IACtB,QAAQ;IACR,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;MACf,kBAAkB;AACxB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;KACf,kBAAkB;GACpB,iBAAiB;AACpB;AACA;KACK,kBAAkB;IACnB,QAAQ;IACR,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;CACC;EACC,wBAAwB;CACzB;EACC,QAAQ,sBAAsB;EAC9B,cAAc,uBAAuB,EAAE,sBAAsB;EAC7D,cAAc,2BAA2B;EACzC,cAAc,2BAA2B;EACzC,eAAe,cAAc,EAAE,yBAAyB,EAAE;EAC1D,mBAAmB,0BAA0B,CAAC;EAC9C,iBAAiB,aAAa,CAAC;EAC/B,qBAAqB,aAAa,EAAE,cAAc,CAAC;CACpD;CACA;EACC;CACD,WAAW;EACV;AACF","sourcesContent":["/* conteneur englobant l'ensemble des informations */\ntable{\n    border-collapse:collapse;\n}\ntr>td {\n  padding: 5px;\n}\ntable,\ntr,\ntd,\ndiv {\n    page-break-inside: avoid;\n}\n.EtiquetteAccessoires{\n\twidth: 7cm;\n\theight: 3cm;\n\tborder: solid 0.1px;\n\n}\n.logoP2BouPromoAccessoiresPrixDebadCenter{\n\tdisplay: inline-block;\n}\n.logoP2BouPromoAccessoiresPromo {\n\tbackground-color: #e8182e;\n    color: #fff;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 70%;\n    height: 19px;\n\t font-size: 10px;\n    font-weight: bold;\n   \n}\n.logoP2BouPromoAccessoiresPrixDebad{\n\t   display: flex;\n    justify-content: center;\n      align-items: end;\n}\n.dlpro-manufacturer-name-custom{\n\tfont-size: 10px;\n    width: 100%;\n}\n.logoP2BouPromoAccessoiresPrixDebad span{\n       font-size: 11px;\n    margin-right: 2px;\n    line-height: 14px;\n}\n.logoP2BouPromoAccessoiresPrixDebad img{\n\t        width: 50%;\n}\n.no-margin-print{margin-top: 20px;}\n.no-margin-top-left{\n\tmargin-top: 20px;\n\tmargin-left: 25px;\n}\n.no-padding-print{\n\tpadding-left: 90px !important;\n}\n.EtiquetteAccessoiresSize{\n\twidth: 7cm;\n\theight: 3cm;\n\n}\n.accessoiresCheckGreen {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n}\n.accessoiresCheckGreen img{\n    width: 20px;\n}  \n.accessoiresBlockTop{\n\tposition: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n\t    margin-top: -10px;    width: inherit;\n}\n.accessoiresBlockTop img{\n\t    width: 70px;\n}\n.accessoiresBlockCenter{\n\tposition: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    text-align: center;\n    margin: 10px 0;\n}\n\n.etiquetteDailyMailing .EtiquetteAccessoires{\n\n}\n.conteneurEtiquetteAccessoires {\n      display: block;\n    width: 7cm;\n\theight: 3cm;\n}\n\n/* conteneur représentant la partie gauche de l'étiquette (logo, ref, caractéristiques) */\n.conteneurCaracteristiquesAccessoires {\n\twidth: 60%;\n    float: left;\n\t    position: relative;\n\t\theight: 100%;\n}\n\n.logoFabricantAccessoires {\n    top: 0;\n    width: 100%;\n}\n\n.logoFabricantAccessoires img {\n  height: 20px;\n  margin: 2px 0 0 2px;\n}\n\n.logoFabricantAccessoires img + img {\n height: 20px;\n    float: right;\n    margin-right: 5px;\n    margin-top: 5px;\n}\n\n.PVCAccessoires img{\n\t    height: 30px;\n}\n\n.bigSizeEtiquetteAccessoires {\n      color: red;\n    font-size: 11px;\n    font-weight: 600;\n   width: 100%;\n    text-align: center;\n    transform: translate(-50%, -50%);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n}\n\n.smallSizeEtiquetteAccessoires {\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.caracteristiquesProduitAccessoires {\n  color: var(--grey-color);\n  font-weight: 600;\n  font-size: 7px;\n      position: absolute;\n    bottom: 0;\n    text-align: center;\n    width: 100%;\n}\n\n/* conteneur représentant la partie droite de l'étiquette (PVC, logo P2B ou Promo, PV) */\n\n.conteneurPrixAccessoires {\n\twidth: 40%;\n\tfloat: left;\n\theight: 100%;\n\toverflow: hidden;\n\t    position: relative;\n}\n\n.PVCAccessoires {\n     color: #000;\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n    \n    background: #ffff;\n    position: relative;\n\t    margin-top: 10px;\n\t\t margin-right: 2px;\n}\n\n.PVCAccessoiresPrice {\n        position: absolute;\n    top: 5px;\n    right: 0;\n    text-align: center;\n    font-size: 12px;\n    line-height: 10px;\n    width: 100%;\n}\n\n.PVCAccessoiresPrice span {\n\ttext-decoration: line-through;\n}\n\n.logoP2BouPromoAccessoires {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n      margin: 20px 0 2px;\n}\n\n\n.PVAccessoires {\n  color: white;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n}\n\n\n.PVAccessoires {\n    color: white;\n    display: flex;\n    flex-direction: column;\n    font-size: 22px;\n    font-weight: 600;\n\t    position: relative;\n\t\t margin-right: 2px;\n}\n.PVAccessoiresPrice{\n\t    position: absolute;\n    top: 2px;\n    right: 0;\n    text-align: center;\n    width: 100%;\n    font-size: 14px;\n}\n@media print {\n\t.no-print{\n\t\tdisplay: none !important;\n\t}\n  table { page-break-after:auto }\n  table tr    { page-break-inside:avoid; page-break-after:auto }\n  table thead { display:table-header-group }\n  table tfoot { display:table-footer-group }\n  .page-break  { display: block; page-break-before: always; }\n  .no-padding-print{ padding-left: 0 !important;}\n  .no-margin-print{margin-top: 0;}\n  .no-margin-top-left{ margin-top: 0; margin-left: 0;}\n }\n @media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
